import React from "react";
import { Mic } from "lucide-react";
import { Ornament } from "../components/Ornament";

/**
 * DESIGN PREVIEW — Conversation screen, "candlelit" dark variant.
 * Keeps the dark navy for the evening/family-together feel, but adds
 * the same gold ornament + serif hierarchy as the rest of the app so
 * the transition doesn't feel jarring.  Static — no logic.
 */
export default function DesignPreviewConversationDark() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#0F1A30", color: "#FAF7F2" }} data-testid="preview-conv-dark">
      {/* Top bar */}
      <header className="px-6 py-5 flex items-center justify-between">
        <button className="text-[#8C8278] hover:text-[#E8D5A3] transition p-2 -ml-2" style={{ minHeight: 44, minWidth: 44 }}>
          ✕
        </button>
        <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.35em]">
          A CHILDHOOD SOUND
        </p>
        <div style={{ width: 44 }} />
      </header>

      {/* Big question */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 pb-8">
        <p className="label-ui text-[11px] text-[#B8973A] tracking-[0.3em] text-center mb-6">
          DAY ONE · STORY WEEK
        </p>
        <h1 className="text-center max-w-2xl"
            style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontWeight: 300,
                     fontSize: "clamp(2.25rem, 7vw, 3.25rem)", lineHeight: 1.2, color: "#FAF7F2" }}>
          Is there a song or piece of music that takes you back to your childhood? What do you remember when you hear it?
        </h1>

        <Ornament className="my-10" color="#B8973A" />

        {/* Ask gently */}
        <div className="w-full max-w-md">
          <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.3em] text-center">ASK GENTLY</p>
          <div className="mt-4 space-y-3 text-center">
            <p className="italic" style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "1.25rem", lineHeight: 1.5, color: "#E8DFC8" }}>
              Where were you when you first heard it?
            </p>
          </div>
          <button className="mt-5 mx-auto block text-[#B8973A] hover:text-[#FAF7F2] transition"
                  style={{ fontFamily: "Georgia, serif", fontSize: "13px", letterSpacing: "0.2em", minHeight: 44 }}>
            Reveal another
          </button>
        </div>
      </main>

      {/* Bottom controls */}
      <footer className="px-6 py-8 flex flex-col items-center gap-5" style={{ background: "#0A1224", borderTop: "1px solid #1F2A45" }}>
        <p className="label-ui text-[24px] tracking-[0.15em]" style={{ color: "#E8DFC8", fontFamily: "Georgia, serif" }}>
          00:00
        </p>
        <button className="btn-gold w-full max-w-sm"
                style={{ minHeight: 72, padding: "20px 40px", fontSize: "15px", letterSpacing: "0.3em", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
          <Mic size={22} /> START RECORDING
        </button>
      </footer>
    </div>
  );
}
